import * as React from 'react';
export const rhoSvg = React.forwardRef(function rhoSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#000',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement(
      'g',
      {
        fill: '#fff',
        clipPath: 'url(#bi_rho__a)',
      },
      /*#__PURE__*/ React.createElement('path', {
        d: 'M7.734 16.545h-2.03v5.032H4V10.29h3.806c2.753 0 3.92.694 3.92 3.137 0 1.77-1.176 2.575-2.34 2.89l2.652 5.262h-1.927l-2.377-5.033Zm.485-.413c1.376 0 1.804-1.14 1.804-2.715s-.428-2.715-2.217-2.715H5.704v5.43h2.515Zm12.201.472v4.973h-1.696v-5.26c0-1.392-.207-2.33-1.692-2.33-1.475 0-2.5 1.469-2.5 2.562v5.029h-1.696V10.289h1.696v5.051a3.332 3.332 0 0 1 3.046-1.955c2.133 0 2.843 1.277 2.843 3.22Zm4.62 5.249c-2.122 0-3.956-1.48-3.956-4.234 0-2.753 1.834-4.234 3.957-4.234 2.122 0 3.956 1.48 3.956 4.234s-1.833 4.234-3.956 4.234Zm0-8.129c-1.9 0-2.149 1.255-2.149 3.895s.25 3.895 2.15 3.895 2.15-1.254 2.15-3.895c0-2.64-.25-3.895-2.15-3.895Z',
      }),
    ),
    /*#__PURE__*/ React.createElement(
      'defs',
      null,
      /*#__PURE__*/ React.createElement(
        'clipPath',
        {
          id: 'bi_rho__a',
        },
        /*#__PURE__*/ React.createElement('path', {
          fill: '#fff',
          d: 'M4 10h25v12H4z',
        }),
      ),
    ),
  );
});
rhoSvg.defaultProps = {
  xmlns: 'http://www.w3.org/2000/svg',
  width: '32',
  height: '32',
  fill: 'none',
  viewBox: '0 0 32 32',
};
export var rho = {
  category: 'brand',
  colorable: false,
  name: 'rho',
  svg: rhoSvg,
};
